<template>
  <div class="panel-container">
    <IntegrationConfigCard
      v-bind="$props"
    />
    <HubSpotForm
      class="workday-panel"
      form-id="15478b52-b97e-48a9-99f9-b2ad9876c966"
    />
  </div>
</template>

<script>
import HubSpotForm from '@/components/settings/integrations/HubSpotForm.vue';
import IntegrationConfigCard from '@/components/settings/integrations/IntegrationConfigCard.vue';

export default {
  name: 'WorkdaySettings',
  components: {
    HubSpotForm,
    IntegrationConfigCard,
  },
  props: {
    atsName: { type: String, default: '' },
    guidance: { type: String, default: '' },
    logoUrl: { type: String, default: '' },
  },
};
</script>

<style scoped lang="less">
  .workday-panel {
    width: calc(50% - 6px);
  }
</style>
